import { closeMobileListing } from './closeMobileListing';
import { LISTING_MODAL_HISTORY_ENTRY } from './constants';
import { toggleModalAction } from './toggleModalAction';
import { EListingModalMode, IToggleListingModalPayload } from './types';
import { TThunkAction } from '../../types/redux';
import { openModalHistoryEntry } from '../../utils/modalHistory';

export { toggleModalAction } from './toggleModalAction';

/** Раскрытый листинг закрывается системным «назад»; в 50/50 свайп вниз, запись в history не нужна. */
export const toggleModal =
  (payload: IToggleListingModalPayload): TThunkAction =>
  dispatch => {
    dispatch(toggleModalAction(payload));

    if (payload.open && payload.mode === EListingModalMode.FULL_SCREEN) {
      openModalHistoryEntry(LISTING_MODAL_HISTORY_ENTRY, () => dispatch(closeMobileListing()));
    }
  };
